import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const backendOptions = {
  loadPath: '/locales/{{lng}}/{{ns}}.json',
};

export const supportedLngs = ['en', 'de', 'es', 'tr'];
export const isSupportedLanguage = (lng: string) =>
  supportedLngs.some((l) => l.toLowerCase() === lng.toLowerCase());

i18n
  // i18next-http-backend
  // loads translations from local JSON files
  // https://github.com/i18next/i18next-http-backend
  .use(HttpBackend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: 'de',
    saveMissing: false, // disabled for local JSON files
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: backendOptions,
    supportedLngs,
    nonExplicitSupportedLngs: true,
    ns: [
      'app_consent',
      'dashboard',
      'translation',
      'settings',
      'classbook',
      'schoollinks',
      'absences',
      'info',
      'homework',
      'courses',
      'workgroups',
      'passwords',
      'timetable',
      'announcement',
      'assignments',
      'videotutorial',
      'reports',
      'files',
      'resources',
      'users',
      'errors',
      'groups',
      'mdm',
      'templates',
      'portalMigration',
      'pc',
    ],
    defaultNS: 'translation',
  });

// eslint-disable-next-line unicorn/prefer-export-from
export default i18n;
